import { Component, computed, input, ChangeDetectionStrategy } from '@angular/core';
import { getReadoutFrequency, PartnerModel, ReadoutFrequency } from '@core/models';
import { TranslateModule } from '@ngx-translate/core';
import { CardComponent } from '@custom-components/general/card/card.component';
import { CardGridComponent } from '@custom-components/general/card-grid';
import { DetailFieldComponent } from '@custom-components/general/detail-field';

@Component({
  selector: 'xemex-company-general-tab',
  imports: [TranslateModule, CardComponent, CardGridComponent, DetailFieldComponent],
  templateUrl: './company-general-tab.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './company-general-tab.component.scss',
})
export class CompanyGeneralTabComponent {
  companyDetail = input<PartnerModel>();
  isLoading = input<boolean>(false);
  /** When true (current user is a Xemex user), the partner admin email field is shown. */
  isXemex = input<boolean>(false);
  /** When true (viewing the user's own partner), the partner admin email field is shown. */
  isOwnPartner = input<boolean>(false);

  /** True when a Xemex user is inspecting another partner's page. Xemex viewing its own
   *  partner page has no meaningful readout/meter-role config to show. */
  showPartnerSettings = computed(() => this.isXemex() && !this.isOwnPartner());

  readoutFrequency = computed((): ReadoutFrequency => getReadoutFrequency(this.companyDetail()));
}
